module.exports = __webpack_public_path__ + "img/ccf-en-US.962d4ad8.png";